import React from 'react';

export function DoneIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M18 32.4l-7.693-7.693a1 1 0 00-1.414 0l-1.386 1.386a1 1 0 000 1.414l9.786 9.786a1 1 0 001.414 0l22.586-22.586a1 1 0 000-1.414l-1.386-1.386a1 1 0 00-1.414 0L18 32.4z" />
    </svg>
  );
}
